export default __webpack_public_path__ + "static/media/Fail.cc67b7bc.svg";